import React from 'react'
import { connect } from 'react-redux'
import { sendContactAction } from '../../../actions/appActions'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import { Button, Grid, TextField, Typography } from '@material-ui/core/index'
import * as queryString from 'query-string'
import { mailRegExp, numberRegExp, phoneRegExp } from '../../../utils/regex'
import ReCAPTCHA from 'react-google-recaptcha'
import {
    removeReCaptchaToken,
    setReCaptchaToken,
} from '../../../helpers/dbHelpers'
import { PhoneNumberFormat } from '../../../utils/formaters'

const initialState = {
    reCaptchaToken: false,
    loader: false,
    formData: {
        platformId: null,
        shopName: '',
        name: '',
        mail: '',
        phoneNumber: '',
        preferredContactFromTime: '09:00',
        preferredContactToTime: '18:00',
    },
    formDataError: {},
}

class Component extends React.Component {
    params = queryString.parse(this.props.location.search)
    platformId = !this.params.platformId ? '' : this.params.platformId
    shopName = !this.params.shopName ? '' : this.params.shopName

    state = {
        ...initialState,
        formData: {
            ...initialState.formData,
            platformId: this.platformId,
            shopName: this.shopName,
        },
    }

    validateFormData() {
        var errors = {}
        if (!this.state.formData.shopName) errors.shopName = true
        if (!this.state.formData.name) errors.name = true
        if (
            !this.state.formData.mail ||
            !mailRegExp.test(this.state.formData.mail)
        )
            errors.mail = true
        if (
            !this.state.formData.phoneNumber ||
            !phoneRegExp.test(this.state.formData.phoneNumber)
        )
            errors.phoneNumber = true
        this.setState({ formDataError: errors })
        if (!Object.keys(errors).length) return true
        return false
    }

    sendContact = () => {
        if (this.validateFormData()) {
            this.setState({ loader: true })
            this.props
                .sendContactAction(this.state.formData)
                .then(() => {
                    window.showDialog(
                        {
                            title: strings.contactSendContactSuccessTitle,
                            message: strings.contactSendContactSuccess,
                        },
                        () => this.setState({ ...initialState })
                    )
                })
                .catch((error) => {
                    window.showDialog(error)
                })
                .finally(() => {
                    removeReCaptchaToken()
                    this.setState({ loader: false, reCaptchaToken: false })
                })
        }
    }

    componentDidMount() {
        removeReCaptchaToken()
    }

    componentWillUnmount() {
        removeReCaptchaToken()
    }

    render() {
        let style = {
            header: { textAlign: 'center' },
            form: { padding: '20px 10px' },
            field: { marginTop: 20 },
            button: { marginBottom: 10 },
        }

        if (this.state.loader) return <Loader />

        return (
            <Grid container style={style.form}>
                <Grid item style={style.header} xs={12}>
                    <Typography variant={'h6'}>
                        {strings.contactHeader}
                    </Typography>
                </Grid>

                <Grid item xs={undefined} sm={2} md={3}></Grid>

                <Grid item xs={12} sm={8} md={6}>
                    <TextField
                        style={{
                            ...style.field,
                            display: !this.shopName ? undefined : 'none',
                        }}
                        label={strings.shopName}
                        placeholder={strings.shopNamePlaceholder}
                        value={this.state.formData.shopName}
                        onChange={(e) =>
                            this.setState({
                                formData: {
                                    ...this.state.formData,
                                    shopName: e.target.value,
                                },
                            })
                        }
                        error={this.state.formDataError.shopName}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />

                    <TextField
                        style={style.field}
                        label={strings.contactName}
                        placeholder={strings.contactNamePlaceholder}
                        value={this.state.formData.name}
                        onChange={(e) =>
                            this.setState({
                                formData: {
                                    ...this.state.formData,
                                    name: e.target.value,
                                },
                            })
                        }
                        error={this.state.formDataError.name}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />

                    <TextField
                        style={style.field}
                        label={strings.contactMail}
                        placeholder={strings.contactMailPlaceholder}
                        value={this.state.formData.mail}
                        onChange={(e) =>
                            this.setState({
                                formData: {
                                    ...this.state.formData,
                                    mail: e.target.value,
                                },
                            })
                        }
                        error={this.state.formDataError.mail}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />

                    <TextField
                        style={style.field}
                        label={strings.contactPhoneNumber}
                        placeholder={strings.contactPhoneNumberPlaceholder}
                        value={this.state.formData.phoneNumber}
                        InputProps={{
                            inputComponent: PhoneNumberFormat,
                        }}
                        onChange={(e) =>
                            !!e.target.value &&
                            !numberRegExp.test(e.target.value)
                                ? 0
                                : this.setState({
                                      formData: {
                                          ...this.state.formData,
                                          phoneNumber: e.target.value,
                                      },
                                  })
                        }
                        error={this.state.formDataError.phoneNumber}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />
                    <Grid container style={style.field}>
                        <Grid item xs={6}>
                            <TextField
                                label={strings.contactPreferredContactFromTime}
                                type="time"
                                value={
                                    this.state.formData.preferredContactFromTime
                                }
                                onChange={(e) =>
                                    this.setState({
                                        formData: {
                                            ...this.state.formData,
                                            preferredContactFromTime:
                                                e.target.value,
                                        },
                                    })
                                }
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label={strings.contactPreferredContactToTime}
                                type="time"
                                value={
                                    this.state.formData.preferredContactToTime
                                }
                                onChange={(e) =>
                                    this.setState({
                                        formData: {
                                            ...this.state.formData,
                                            preferredContactToTime:
                                                e.target.value,
                                        },
                                    })
                                }
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>
                    </Grid>

                    <ReCAPTCHA
                        style={{ width: 300, margin: '40px auto' }}
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={(token) => {
                            setReCaptchaToken(token)
                            this.setState({ reCaptchaToken: true })
                        }}
                    />

                    <Button
                        style={style.button}
                        label={strings.contactSearchButton}
                        variant="contained"
                        color="primary"
                        onClick={this.sendContact}
                        disabled={!this.state.reCaptchaToken}
                        fullWidth
                    >
                        {strings.contactSubmitButton}
                    </Button>
                </Grid>
            </Grid>
        )
    }
}

const mapDispatchToProps = { sendContactAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
